"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  name: 'BasisNoPermission',
  // 没有权限提示组件
  props: {
    title: {
      type: String,
      default: '没有访问权限'
    },
    subTitle: {
      type: String,
      default: '您的访问请求被拒绝了哦，请联系管理员吧！'
    }
  }
};